// app/context/ProfileContext.tsx
"use client";

import { createContext, useContext, ReactNode } from "react";
import { useProfile } from "@/app/hooks/useProfile";

type ProfileContextType = ReturnType<typeof useProfile>;

const ProfileContext = createContext<ProfileContextType | null>(null);

export function ProfileProvider({ children }: { children: ReactNode }) {
  const profile = useProfile();
  return (
    <ProfileContext.Provider value={profile}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfileContext() {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfileContext must be used inside ProfileProvider");
  return ctx;
}